



















import { Component, Prop, Vue, Watch, Mixins, Emit } from 'vue-property-decorator';
import Selection from '@/components/extrinsics/Selection.vue';
import Executor from '@/components/extrinsics/Executor.vue';
import Argurments from '@/components/extrinsics/Arguments.vue';
import ExtrinsicMixin from '@/utils/mixins/extrinsicsMixin'
import Connector from '@vue-polkadot/vue-api';
import extractParams, {StorageEntryPromise} from './extractParams'
import { getTypeDef } from '@polkadot/types';
import { TypeDef } from '@polkadot/types/types';


const components = {
  Selection,
  Executor,
  Argurments,
}

@Component({ components })
export default class Storage extends Mixins(ExtrinsicMixin) {

  public mounted(): void {
    const { api } = Connector.getInstance()
    this.setSection(api.query)
  }

  protected handleMethod(value: string) {
    this.handleMethodSelection(value)

    const params = extractParams(this.getSection() as StorageEntryPromise)
    console.log(params);
    
  
    this.setArgs(params.map(({type}, index) =>  ({ ...type, name: index })))
    console.log(this.mapArgs());
    
  }

  get disabled() {
    return this.hasArgs() && !this.mapArgs().filter(v => !!v).length 
  }

  @Emit('click')
  public handleClick() {
    const { fnMethod, fnSection } = this.getFnMethodAndSection();
    const storageEntryPromise: StorageEntryPromise = this.getSection() as StorageEntryPromise;
    const key: TypeDef = { ...getTypeDef(this.handleType(storageEntryPromise)), name: `${fnSection}::${fnMethod}` };
    
    return { key, method: this.getSection(), args: this.mapArgs() }
  }


  private handleType(storageEntryPromise: StorageEntryPromise): string {
    const { type } = storageEntryPromise.creator.meta;
    const { isPlain, isMap, isDoubleMap } = type;

    if (isPlain) {
      return type.asPlain.toString();
    }

    if (isMap) {
      return ''
      // return type.asMap.key.toString()
    }

    // TODO: not so correct
    if (isDoubleMap) {
      return ''
      // return type.asDoubleMap.key1.toString()
    }

    return ''
  }
  

}
